import { Link } from "react-router-dom";
import { TYPE_ICONS, TYPE_LABELS, TYPE_PATHS, TYPE_TAGLINES } from "@/constants/media";
import type { MediaType } from "@/types/media";

interface CategoryEntryProps {
  counts: Record<MediaType, number>;
}

const ORDER: MediaType[] = ["tv", "movie", "variety"];

export default function CategoryEntry({ counts }: CategoryEntryProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
      {ORDER.map((type) => (
        <Link
          key={type}
          to={TYPE_PATHS[type]}
          className="group relative overflow-hidden rounded-lg border border-secondary-200 bg-background-50 p-5 transition-all hover:border-accent-300 hover:bg-accent-50/60 cursor-pointer animate-fade-up"
        >
          <div className="flex items-start justify-between">
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-600 text-white transition-colors group-hover:bg-accent-500">
              <i className={`${TYPE_ICONS[type]} text-2xl`}></i>
            </span>
            <span className="font-heading text-3xl font-extrabold text-secondary-200 transition-colors group-hover:text-accent-200">
              {String(counts[type]).padStart(2, "0")}
            </span>
          </div>
          <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
            {TYPE_LABELS[type]}频道
          </h3>
          <p className="mt-1 text-sm text-foreground-500">{TYPE_TAGLINES[type]}</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-accent-600">
            进入频道
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
          </span>
        </Link>
      ))}
    </div>
  );
}